import React from "react";
import CurrencyInput from "react-currency-input-field";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import { colors } from "UI/colors";

export default function AmountRow({
  value,
  setValue,
  amountInputRef,
  hasAmountValidationError,
  setAmountValidationError,
  isSaving,
  isArchived,
  amountValidationError,
}) {
  const handleFocus = (e) => {
    if (Number(value) === 0) {
      e.target.setSelectionRange(0, 0);
    }
  };

  const noValue = value === "" || !value || value === "0.00" || value === "0";

  return (
    <Amount>
      <AmountLabel htmlFor="item-amount">{`Price: `}</AmountLabel>

      <InputWrapper>
        <DollarSign>$</DollarSign>

        <Input
          ref={amountInputRef}
          className={`${hasAmountValidationError ? "has-error" : ""}`}
          id="item-amount"
          name="item-amount"
          value={noValue ? "" : value} // doing this causes the cursor to jump to wonky places when typing from 0
          // value={isNaN(Number(value)) ? "" : value}
          placeholder={"0.00"}
          onValueChange={(v) => {
            setAmountValidationError("");
            setValue(v);
          }}
          maxLength={8}
          allowNegativeValue={false}
          decimalScale={2}
          disabled={isSaving || isArchived}
          autoFocus
          onFocus={handleFocus}
        />
      </InputWrapper>
      <AnimatePresence>
        {!isSaving && hasAmountValidationError && (
          <ValidationError
            initial={{ opacity: 0, y: -4, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -4, height: 0 }}
          >
            <ValidationErrorInside>
              {amountValidationError}
            </ValidationErrorInside>
          </ValidationError>
        )}
      </AnimatePresence>
    </Amount>
  );
}

const Amount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
`;

const AmountLabel = styled.label`
  ${({
    theme: {
      colors: { textPrimary },
    },
  }) => `color: ${textPrimary}`}
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
`;

const DollarSign = styled.div`
  position: absolute;
  margin-left: 16px;
  font-size: 18px;
  color: #333;
  opacity: 0.8;
  font-weight: 400;
  z-index: 100;
`;

const Input = styled(CurrencyInput)`
  font-weight: 400;
  box-sizing: border-box;
  font-size: 18px;
  border-radius: 10px;
  border: none;
  padding: 12px 16px 12px 28px;
  color: #333;
  outline: none;
  background: #fff;
  transition: border-color 200ms, box-shadow 200ms;
  width: 140px;

  &:focus {
    box-shadow: 0 0 0 1px #278dc1b5;
  }

  &:focus-visible {
    /* box-shadow: 1px 1px 3px 2px rgba(0, 0, 0, 0.1); */
    border-color: ${colors.fnBlue400};
  }

  &.has-error {
    border-color: ${colors.fnRed};
  }

  &:placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const ValidationError = styled(motion.div)`
  font-weight: 400;
  width: 100%;
  text-align: right;
  color: ${colors.fnRed};
`;
const ValidationErrorInside = styled.div`
  padding-top: 4px;
`;
